<template>
    <div></div>
</template>
<script>
import Interface from "@/util/interface"
import {LocationHref} from '@/util/common'

export default {
    name: 'middle',
    methods : {
        goPath(){
            if(this.$route.query.path == undefined){
                this.$router.push({
                    path: "/"
                })
            }else{
                this.$router.push({
                    path: this.$route.query.path
                })
            }
        }
    },
    created() {
        if(this.$route.query.union_id){
            localStorage.setItem("union_id", this.$route.query.union_id)
            Interface.getData('get', Interface.user.union_login, {
                union_id: this.$route.query.union_id,
            }).then((res) => {
                if (res.code === 0) {
                    localStorage.setItem("user", JSON.stringify(res.data.user))
                    localStorage.setItem("access_token", res.data.access_token)
                    localStorage.setItem("user_id", res.data.user.id)
                } else if (res.code === 1) {
                    localStorage.setItem("user", JSON.stringify(res.data.user))
                    localStorage.setItem("access_token", res.data.access_token)
                    localStorage.setItem("user_id", res.data.user.id)
                } else {
                    this.error = true;
                    this.$toast.fail(res.message);
                    setTimeout( ()=>{
                        LocationHref(Interface.api + "/wechat-phase/wxOauth?redirect_url=" + Interface.host + "&path=" + this.$route.query.path)
                    }, 3000)
                }
                this.goPath()
            })
        }else{
            if(this.$route.query.search_channel > 0){
                sessionStorage.setItem("search_channel",this.$route.query.search_channel)
            }
            let res = localStorage.getItem("user")
            if (res == null) {
                LocationHref(Interface.api + "/wechat-phase/wxOauth?redirect_url=" + Interface.host + "&path=" + this.$route.path)
            }else{
                this.goPath()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/middle/index.vue